<template>
  <div class="login-input" :class="{ active: clazz ? true : false }">
    <slot></slot>
    <input
      :type="type"
      :placeholder="placeholder"
      :value="value"
      :auto-Complete="autoComplete"
      :maxlength="maxlength"
      :bool="bool"
      :phone="phone"
      @input="onInput"
      @blur="onBlur"
      @keyup="onKeyup"
    />
    <span v-if="bool" class="getCode" @click.stop="countdown">{{
      content
    }}</span>
  </div>
</template>

<script>
import regexps from '@/utils/regexps'
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    clazz: {
      type: Boolean,
      default: false
    },
    autoComplete: {
      type: String,
      default: 'on'
    },
    prefix: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number
    },
    bool: {
      type: Boolean
    },
    phone: {
      type: String
    }
  },
  data() {
    return {
      content: '获取验证码', // 按钮里显示的内容
      totalTime: 60, //记录具体倒计时时间,
      isClose: false
    }
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value)
    },
    onBlur(e) {
      this.$emit('blur', e.target.value)
    },
    onKeyup(e) {
      this.$emit('keyup', e.target.value)
    },

    async countdown(val) {
      if (this.content !== '获取验证码') {
        console.log('1')
        return
      }
      console.log('2')

      let that = this
      if (!regexps.phone.test(this.phone)) {
        this.$alert.error('请正确输入手机号')
        return
      }

      const {
        $store: { dispatch }
      } = this

      if (this.content == '获取验证码') {
        console.log(3)
        this.content = '发送中'

        dispatch('login/sendVerificationCode', {
          phone: this.phone,
          smsKey: 'loginCode'
        }).then(res => {
          // this.isClose = true
          // let clock = window.setInterval(() => {
          //   if (that.totalTime > 0) {
          //     that.totalTime--
          //     that.content = that.totalTime + 's'
          //   } else {
          //     that.content = '获取验证码'
          //     window.clearInterval(clock)
          //     that.totalTime = 60
          //   }
          // }, 1000)
          if ((that.totalTime = 60)) {
            var bo_clock = window.setInterval(function() {
              that.totalTime--
              that.content = that.totalTime + 's'
              if (that.totalTime < 0) {
                window.clearInterval(bo_clock)
                that.content = '获取验证码'
                that.totalTime = 60
              }
            }, 1000)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-input {
  display: flex;
  width: 273px;
  padding: 3px 6px;
  background: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;

  /deep/ .input-prefix__icon {
    line-height: 34px;
    width: 60px;
    text-align: center;

    .input-prefix-icon {
      width: 20px;
      height: 20px;
      margin: 0px 14px;
    }
  }

  input {
    width: 100%;
    height: 36px;
    line-height: 36px;
    padding: 0px 18px;
    border: 0;
    outline: 0;
    background: transparent;
    font-weight: 900;
    font-size: 14px;
    color: #505050;

    &::placeholder {
      font-weight: normal;
    }

    .active input::-webkit-input-placeholder {
      color: red;
    }
    .active input::-moz-input-placeholder {
      color: red;
    }
    .active input::-ms-input-placeholder {
      color: red;
    }
  }

  .getCode {
    width: 120px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 12px;
    color: var(--primary);
    cursor: pointer;
  }
}
</style>
